import React, { useEffect } from 'react'
import { callTokenApi } from '../../../../apiCaller'
import { ADMIN_ACCOUNTS } from '../../../../constants';
import classNames from 'classnames';
import SelectSearch from './SelectSearch';
import { toastError } from '../../../../utils';
import CIcon from '@coreui/icons-react';

const SelectAccounts = ({ filterAccount, setFilterAccount }) => {
     const [accounts, setAccounts] = React.useState([]);

     useEffect(() => {
          callTokenApi(ADMIN_ACCOUNTS, 'GET').then((response) => {
               if (response.status === 200) {
                    const { accounts } = response.data;

                    setAccounts(
                         accounts.map(account => ({
                              value: account.id,
                              label: account.name
                         }))
                    );
               } else {
                    toastError(response);
               }
          });
     }, []);

     const handleChangeRowData = (selected) => {
          setFilterAccount(selected.value)
     };

     return (
          <div className='d-flex align-items-center'>
               <span>Select Account: </span>
               <div className='mx-4' style={{width: '400px'}}>
                    <SelectSearch
                         classNamePrefix="react-select"
                         name="account-select"
                         classNameWrapper={classNames(
                              {
                                   'disable-select': false,
                              }
                         )}
                         noOptionsMessage={() => <span>No options available.</span>}
                         onChange={handleChangeRowData}
                         value={accounts.find((item) => item.value === filterAccount) || {label: "Select an account"}}
                         placeholder="Select an account"
                         options={accounts}
                    />
               </div>
               <CIcon
                    name='iconDeleteField'
                    className={`icon-delete`}
                    onClick={() => setFilterAccount('')}
               />
          </div>
     )
}

export default SelectAccounts